import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import AsyncSelect from "react-select/async";
import { Input, Label } from "reactstrap";
import { ToolTip } from "../../../../AbstractElements";
import { PlusCircle } from "react-feather";

export const CustomerSelector = ({
	t,
	isHospitalConnected,
	hospitalData,
	customerType,
	onCustomerTypeChange,
	walkingCustomerName,
	onWalkingNameChange,
	customerError,
	patientSelectRef,
	loadPatients,
	onPatientChange,
	hasNewCustomer,
	onCreateCustomerClick,
	createTooltipOpen,
	toggleCreateTooltip,
	disableScrollProps,
	selectedPatientOption
}) => {
	const isDark = document.body.classList.contains("dark-only");
	const renderAsyncSelect = () => (
		<AsyncSelect
			cacheOptions
			defaultOptions
			loadOptions={loadPatients}
			onChange={onPatientChange}
			value={selectedPatientOption}
			placeholder={customerType === "hospital_patient" ? t("Search patient by name or phone...") : t("Search customer by name or phone...")}
			noOptionsMessage={({ inputValue }) =>
				inputValue.length < 3 ? t("Type at least 3 characters") : t("No patients found")
			}
			isClearable
			menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
			menuShouldScrollIntoView
			theme={(theme) => ({
				...theme,
				colors: {
					...theme.colors,
					primary25: isDark ? "#373737" : "#e6f7ffff",

				},
			})}
		/>
	);

	const renderWalkingInput = () => (
		<Form.Control
			type="text"
			value={walkingCustomerName}
			onChange={(e) => onWalkingNameChange(e.target.value)}
			placeholder={t("Enter customer name")}
			className="search-product"
			isInvalid={customerError}
			{...disableScrollProps}
		/>
	);

	return (
		<Row className="mb-1 g-2 align-items-center">
			{/* {isHospitalConnected && ( */}
			<Col sm="auto" md="3" lg="auto">
				<Form.Label className="mb-0 pe-2">{t("Customer")}:</Form.Label>
			</Col>
			<Col sm="auto" md="3" lg="auto">
				<div className="radio radio-primary">
					<Input
						id="customer-radio-walking"
						type="radio"
						name="customerType"
						value="walking"
						checked={customerType === "walking"}
						onChange={() => onCustomerTypeChange("walking")}
					/>
					<Label for="customer-radio-walking" className="mb-0 pe-2">
						{t("Walk-in")}
					</Label>
				</div>
			</Col>
			<Col sm="auto" md="3" lg="auto">
				<div className="radio radio-primary">
					<Input
						id="customer-radio-existing"
						type="radio"
						name="customerType"
						value="inpatient"
						checked={customerType === "inpatient"}
						onChange={() => onCustomerTypeChange("inpatient")}
					/>
					<Label for="customer-radio-existing" className="mb-0 pe-2">
						{t("Existing")}
					</Label>
				</div>
			</Col>
			{isHospitalConnected && (
				<Col sm="auto" md="3" lg="auto">
					<div className="radio radio-primary">
						<Input
							id="customer-radio-hospital_patient"
							type="radio"
							name="customerType"
							value="hospital_patient"
							checked={customerType === "hospital_patient"}
							onChange={() => onCustomerTypeChange("hospital_patient")}
						/>
						<Label for="customer-radio-hospital_patient" className="mb-0 pe-2">
							{t("Clinic")}
						</Label>
					</div>
				</Col>
			)
			}
			{/* )} */}
			<Col md="9" lg="6">
				<div className="async-select-container" style={{ position: "relative" }}>
					{customerType === "inpatient" || customerType === "hospital_patient"
						? renderAsyncSelect()
						: renderWalkingInput()}
				</div>
			</Col>
			<Col sm="auto">
				{customerType === "inpatient" && (
					<button
						className="btn btn-primary w-100 d-flex align-items-center"
						to=""
						id="CreateToolTip"
						onClick={onCreateCustomerClick}
					>
						<PlusCircle size={24} />
						<ToolTip
							attrToolTip={{
								placement: "top",
								isOpen: createTooltipOpen,
								target: "CreateToolTip",
								toggle: toggleCreateTooltip,
							}}
						>
							<strong>{t("Create A New Customer")}</strong>
						</ToolTip>
					</button>
				)}
			</Col>
		</Row>
	);
};

export default CustomerSelector;

